import axios from "axios";

var getAuthUser = function getAuthUser() {
  return axios.get("/user");
};

var updateAuthUser = function updateAuthUser(userId, request) {
  return axios.put("/user/".concat(userId), request);
};

var getOrganizationUsers = function getOrganizationUsers(organizationId) {
  var page = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  return axios.get("/organizations/" + organizationId + "?include=users.userGroups,groups&page=" + page);
};

var getOrganizationUsersInGroup = function getOrganizationUsersInGroup(groupId) {
  return axios.get("groups/".concat(groupId, "/organization-users"));
};

var storeOrganizationUser = function storeOrganizationUser(organizationId, request) {
  return axios.post("organizations/" + organizationId + "/users/", request);
};

var updateOrgUser = function updateOrgUser(orgnanisationId, userId, request) {
  return axios.put("organizations/" + orgnanisationId + "/users/" + userId, request);
};

var deleteOrganizationUser = function deleteOrganizationUser(organizationId, userId) {
  return axios.delete("organizations/".concat(organizationId, "/users/").concat(userId));
};

var getMembers = function getMembers(groupId) {
  var page = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  return axios.get("groups/".concat(groupId, "/users?include=groupRoles&page=").concat(page));
};

var storeMember = function storeMember(groupId, request) {
  return axios.post("groups/".concat(groupId, "/users"), request);
};

var deleteMember = function deleteMember(groupId, memberId) {
  return axios.delete("groups/".concat(groupId, "/users/").concat(memberId));
};

var updateMember = function updateMember(groupId, memberId, request) {
  return axios.put("groups/".concat(groupId, "/users/").concat(memberId), request);
};

var getParticipants = function getParticipants(groupId, meetingId) {
  return axios.get("groups/" + groupId + "/meetings/" + meetingId + "/participants?include=groupJobs");
};

var storeParticipant = function storeParticipant(groupId, meetingId, request) {
  return axios.post("groups/" + groupId + "/meetings/" + meetingId + "/participants", request);
};

var updateParticipant = function updateParticipant(groupId, meetingId, request) {
  return axios.put("groups/" + groupId + "/meetings/" + meetingId + "/participants", request);
};

var deleteParticipant = function deleteParticipant(groupId, meetingId, request) {
  return axios.put("groups/" + groupId + "/meetings/" + meetingId + "/participants/delete", request);
};

export { getAuthUser, updateAuthUser, getOrganizationUsers, getOrganizationUsersInGroup, storeOrganizationUser, updateOrgUser, deleteOrganizationUser, getMembers, storeMember, updateMember, deleteMember, getParticipants, storeParticipant, updateParticipant, deleteParticipant };